import {
  USERS_BY_PROJECT_FETCH_STARTED,
  USERS_BY_PROJECT_FETCH_SUCCEEDED,
  USERS_BY_PROJECT_FETCH_FAILED,
  USERS_BY_PROJECT_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  projectId: null,
  items: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USERS_BY_PROJECT_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case USERS_BY_PROJECT_FETCH_SUCCEEDED:
      const { users, projectId } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        projectId,
        items: users
      };
    case USERS_BY_PROJECT_FETCH_FAILED:
      return { ...state, status: statuses.failed, projectId: null, items: [], error: action.error };
    case USERS_BY_PROJECT_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
